<template>
    <div class="favourites-component" @click="goToFavourites">
      <v-badge
        color="yellow"
        :content="getCount"
        offset-x="-2"
        offset-y="2"
        :dot="!getCount"
      >
        <v-icon icon="mdi-heart-outline" color="primary"></v-icon>
      </v-badge>
    </div>


</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'FavouritesComponent',
  computed: {
    ...mapGetters('favouritesModule', ['getCount']),
  },
  mounted() {
    this.$store.dispatch('breadcrumbModule/setRoute', [{
      name: 'breadcrumb.want_to_be_a_parent',
      url: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`,
      absolute: true
    },{
      name: 'breadcrumb.dashboard',
      url: '/dashboard?selected=personal-details'
    },
    {
      name: 'breadcrumb.dashboard_labels.favourites',
      url: ''
    }
    ])
  },
  methods: {
    goToFavourites() {
      this.$router.push({ name: 'dashboardView', query: {selected: "favourites"} })
    }
  }
}
</script>

<style lang="scss" scoped>

.v-col {
    padding: 0 !important;
}
  .favourites-component {
    cursor: pointer;
    :deep(.v-badge) {
      &.v-badge--dot{
        .v-badge__badge {
          width: 0px;
          height: 0px;
          font-size: 0px;
        }
      }
      .v-badge__badge {
        @include nsb-font-header-bold;
        color: $ds-primary !important;
        font-size: 10px;
        line-height: 12px;
        padding-top: 5px;
      }
    }
  }
</style>